import React from 'react';
import { Skeleton } from '@cubeyou-team/hx-react-components';

const SingleItemLoader = () => {
  const speed = 2;
  return (
    <React.Fragment>
      <Skeleton speed={speed} width={340} height={58} viewBox="0 0 340 58">
        <circle cx="73" cy="30" r="20" />
        <rect x="18" y="22" rx="4" ry="4" width="14" height="16" />
        <rect x="108" y="18" rx="4" ry="4" width="40" height="8" />
        <rect x="162" y="14" rx="4" ry="4" width="40" height="16" />
        <rect x="108" y="37" rx="4" ry="4" width="300" height="8" />
      </Skeleton>
    </React.Fragment>
  );
};
export default SingleItemLoader;
